module.exports = __webpack_public_path__ + "static/media/shop_beach_2.89ababf6.svg";